<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-view">
		<vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
			<span>User record with id: {{ $route.params.userId }} not found. </span>
			<span>
				<span>Check </span>
				<router-link :to="{name: 'page-user-list'}" class="text-inherit underline"> All Users </router-link>
			</span>
		</vs-alert>
		<bread-crumbs
			:title="$t('general.Visualize') + ' ' + $t('Resource.Resource')"
			:subTitle="$t('general.SubtitleDetailedInformation') + ' ' + $t('Resource.Resource')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		>
		</bread-crumbs>
		<div id="user-data" v-if="resource_data">
			<vx-card class="mb-base">
				<span class="g-subtitle" v-text="$t('Information')"></span>
				<!-- Avatar -->
				<div class="vx-row mt-4">
					<!-- Avatar Col -->
					<div class="vx-col mt-4" id="avatar-col">
						<div class="img-container">
							<vs-avatar size="120px" :src="avatar" />
						</div>
					</div>
					<!-- Information - Col 1 -->
					<div class="vx-col flex-1 mt-4" id="account-info-col-1">
						<table>
							<tr>
								<td class="g-table--title" v-text="$t('general.User')"></td>
								<td class="g-label--normal">{{ resource_data.username }}</td>
							</tr>
							<tr>
								<td class="g-table--title" v-text="$t('Identification')"></td>
								<td class="g-label--normal">{{ resource_data.identification }}</td>
							</tr>
							<tr>
								<td class="g-table--title" v-text="$t('Name')"></td>
								<td class="g-label--normal">{{ resource_data.name }}{{ resource_data.lastname }}</td>
							</tr>
							<tr>
								<td class="g-table--title" v-text="$t('Login.Email')"></td>
								<td class="g-label--normal">{{ resource_data.email }}</td>
							</tr>
							<tr>
								<td class="g-table--title" v-text="$t('Role')"></td>
								<td class="g-label--normal">{{ resource_data.role_name }}</td>
							</tr>
						</table>
					</div>
					<div class="vx-col flex-1 mt-4" id="account-info-col-2">
						<table>
							<tr>
								<td class="g-table--title" v-text="$t('Company')"></td>
								<td class="g-label--normal">{{ resource_data.company_name }}</td>
							</tr>
							<tr>
								<td class="g-table--title">{{ $t("Resource.Resource") }} {{ $t("Type") }}</td>
								<td class="g-label--normal">{{ resource_data.typology_name | capitalize }}</td>
							</tr>
							<tr>
								<td class="g-table--title" v-text="$t('TypeConfigAddDateOn')"></td>
								<td class="g-label--normal">{{ addedOn }}</td>
							</tr>
							<tr>
								<td class="g-table--title" v-text="$t('Status')"></td>
								<td class="g-label--normal">{{ resource_data.status }}</td>
							</tr>
						</table>
					</div>
					<!-- /Information - Col 2 -->
					<div class="vx-col w-full flex justify-end" id="account-manage-buttons">
						<vs-button
							type="filled"
							icon-pack="feather"
							icon="icon-edit"
							class="mr-4"
							:size="iconSize"
							:title="$t('Crud.Update')"
							:to="{
								name: 'app-resource-edit',
								params: {userId: $route.params.userId},
							}"
							>{{ windowWidth > 620 ? $t("Crud.Update") : null }}
						</vs-button>
						<vs-button
							v-if="resourceDeletePermission"
							type="filled"
							color="danger"
							icon-pack="feather"
							icon="icon-trash"
							:size="iconSize"
							:title="$t('Crud.Delete')"
							@click="confirmDeleteRecord"
							>{{ windowWidth > 620 ? $t("Crud.Delete") : null }}
						</vs-button>
						<vs-button
							class="ml-4"
							type="filled"
							color="success"
							icon-pack="feather"
							icon="icon-list"
							:size="iconSize"
							:title="$t('CreatePasswordVP.GoTo') + ' ' + $t('ResourceList')"
							:to="{name: 'app-resource-list'}"
							>{{ windowWidth > 620 ? $t("CreatePasswordVP.GoTo") + " " + $t("ResourceList") : null }}
						</vs-button>
					</div>
				</div>
			</vx-card>
			<vx-card class="mb-base">
				<vs-tabs v-model="activeTab">
					<vs-tab icon-pack="feather" icon="icon-box" :label="$t('Object.AdditionalFields')">
						<vs-tabs
							v-if="
								Object.keys(additionalFieldsFile).length > 0 ||
								Object.keys(additionalFieldsBasics).length > 0 ||
								Object.keys(additionalFieldsImg).length > 0
							"
							position="left"
							color="success"
						>
							<vs-tab
								v-if="Object.keys(additionalFieldsBasics).length > 0"
								icon-pack="feather"
								icon="icon-file-text"
								:label="$t('Object.Basics')"
							>
								<vx-card no-shadow card-border>
									<table class="mt-base">
										<tr v-for="(val, name) in additionalFieldsBasics" :key="name">
											<td class="g-table--title">{{ name | capitalizeFilter }}</td>
											<td class="g-label--normal">{{ val }}</td>
										</tr>
									</table>
								</vx-card>
							</vs-tab>
							<vs-tab
								v-if="Object.keys(additionalFieldsFile).length > 0"
								icon-pack="feather"
								icon="icon-file"
								:label="$t('general.Files')"
							>
								<div class="vx-row" v-if="Object.keys(additionalFieldsFile).length > 0">
									<div
										class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base mt-base"
										v-for="(val, name) in additionalFieldsFile"
										:key="name"
									>
										<vx-card card-border>
											<img
												:src="renderImgFileExtension(val)"
												style="height: 90px; width: 100%"
												:title="renderImgFileCompleteName(val)"
												class="rounded w-full"
											/>
											<div class="flex justify-between mt-2">
												<label class="g-table--title mr-2" v-text="$t('Name')"></label>
												<table>
													<tr>
														<td class="g-label--normal">
															{{ renderImgFileCompleteName(val) }}
														</td>
													</tr>
												</table>
											</div>
											<vs-button
												class="w-full"
												color="primary"
												:title="$t('ManualData.DownloadFile')"
												icon-pack="feather"
												icon="icon-download"
												@click="downloadFile(val)"
												>{{ $t("ManualData.DownloadFile") }}
											</vs-button>
										</vx-card>
									</div>
								</div>
							</vs-tab>
							<vs-tab
								v-if="Object.keys(additionalFieldsImg).length > 0"
								icon-pack="feather"
								icon="icon-image"
								:label="$t('general.Images')"
							>
								<div v-if="mounted">
									<swiper
										class="swiper"
										:options="swiperOption"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										:key="$vs.rtl"
									>
										<swiper-slide
											v-for="(val, name) in additionalFieldsImg"
											:key="name"
											class="slide"
										>
											<div class="flex flex-row justify-end">
												<vs-button
													icon-pack="feather"
													icon="icon-download"
													class="mt-2 mr-6 mb-2 g-label--normal text-white"
													:title="$t('ManualData.DownloadFile')"
													@click="downloadFile(val)"
													>{{ $t("ManualData.Download") }}
												</vs-button>
											</div>
											<img class="responsive" :src="val" alt="banner" />
										</swiper-slide>
										<div class="swiper-button-prev" slot="button-prev"></div>
										<div class="swiper-button-next" slot="button-next"></div>
									</swiper>
								</div>
							</vs-tab>
						</vs-tabs>
						<vs-alert v-else active class="mb-5" color="primary">
							<span class="g-label--normal text-primary"> {{ $t("Object.NotAdditionalFields") }} </span>
						</vs-alert>
					</vs-tab>
					<vs-tab :label="'Imei'" icon-pack="feather" icon="icon-cpu">
						<vx-card no-shadow card-border class="mb-base mt-base">
							<vx-input-group v-if="resource_data.imei" class="mt-4">
								<vs-input
									name="name"
									class="w-full"
									icon-pack="feather"
									icon="icon-smartphone"
									icon-no-border
									v-model="resource_data.imei"
									readonly
								/>
								<template slot="append">
									<div class="append-text btn-addon">
										<vs-button
											icon-pack="feather"
											icon="icon-trash"
											type="filled"
											color="danger"
											:title="$t('Crud.Delete') + ' ' + 'IMEI'"
											:size="iconSize"
											:disabled="resource_data.imei ? false : true"
											@click="confirmDeleteImei"
											>{{ windowWidth > 620 ? $t("Crud.Delete") + " " + "IMEI" : null }}
										</vs-button>
									</div>
								</template>
							</vx-input-group>
							<vs-alert v-else active class="mb-5" color="primary">
								<span class="g-label--normal text-primary">
									{{ $t("Resource.View.NotImeiCode") }}
								</span>
							</vs-alert>
						</vx-card>
					</vs-tab>
					<vs-tab :label="$t('VisitPointObject.AssignedVisitPoints')" icon-pack="feather" icon="icon-map-pin">
						<div v-if="resource_data && resource_data.visit_point_id" class="vx-row">
							<div class="vx-col w-full flex justify-end">
								<vs-button
									id="buttonMap"
									color="gray"
									size="medium"
									:title="!showMap ? $t('Routing.Map.ShowMap') : $t('Routing.Map.HideMap')"
									:icon="showMap ? 'location_off' : 'location_on'"
									@click.stop="showMap = !showMap"
								></vs-button>
							</div>
						</div>
						<div v-if="resource_data && resource_data.visit_point_id" class="vx-row">
							<div :class="showMap ? 'vx-col w-full md:w-3/5' : 'vx-col w-full'">
								<vx-card no-shadow card-border class="mb-base mt-base">
									<div id="visit-points-content-loading" class="vs-con-loading__container">
										<visit-point-assigned-list
											class="p-4"
											:navbarOptions="false"
											:visit_point_ids="resource_data.visit_point_id"
											:maxHeight="'320px'"
											@renderMap="renderMapEmit"
										></visit-point-assigned-list>
									</div>
								</vx-card>
							</div>
							<div v-show="showMap" class="vx-col w-full md:w-2/5 mt-base mt-base">
								<here-map
									v-if="renderComponentMap"
									name="theMap"
									ref="moduleMap"
									latitude="4.686699"
									longitude="-74.0837187"
									zoom="13"
									:width="widthMap"
									height="100vh"
									theme="uber"
									calledFrom="calendar"
								></here-map>
							</div>
						</div>
						<vx-card no-shadow card-border class="mb-base mt-base" v-else>
							<vs-alert active class="mb-5" color="primary">
								<span class="g-label--normal text-primary">
									{{ $t("VisitPointObject.NoAssignedVisitPoints") }}
								</span>
							</vs-alert>
						</vx-card>
					</vs-tab>
					<vs-tab :label="$t('Alarm.AssignedZones')" icon-pack="feather" icon="icon-layers">
						<vx-card
							no-shadow
							card-border
							class="mb-base mt-base"
							:title="$t('Alarm.AssignedZones') + ' ' + resourceViewAssignedZones.length"
							v-if="mountedMapTab4 && resourceViewAssignedZones.length > 0"
						>
							<here-map
								v-if="mountedMapTab4"
								name="map-iot"
								ref="moduleMap4"
								latitude="4.686699"
								longitude="-74.0837187"
								zoom="13"
								:width="'100%'"
								height="100vh"
								theme="uber"
								calledFrom="calendar"
								:resourceViewActiveTab="activeTab"
								:resourceViewAssignedZones="resourceViewAssignedZones"
							></here-map>
						</vx-card>

						<vx-card
							no-shadow
							card-border
							:title="$t('Alarm.AssignedZones')"
							class="mb-base mt-base"
							v-else
						>
							<vs-alert active class="mb-5" icon-pack="feather" icon="icon-shopping-bag" color="primary">
								<span> {{ $t("general.NoZonesAssigned") }} </span>
							</vs-alert>
						</vx-card>
					</vs-tab>
					<vs-tab :label="$t('Resource.View.AssignedActivities')" icon-pack="feather" icon="icon-tag">
						<vx-card no-shadow card-border class="mb-base mt-base" v-if="resource_data.activity_id">
							<div id="activity-content-loading" class="vs-con-loading__container">
								<assigned-activity-list
									class="p-4"
									:navbarOptions="false"
									:activityListIds="resource_data.activity_id"
								>
								</assigned-activity-list>
							</div>
						</vx-card>
						<vx-card no-shadow card-border class="mb-base mt-base" v-else>
							<vs-alert active class="mb-5" color="primary">
								<span class="g-label--normal text-primary">
									{{ $t("Resource.View.NotAssignedActivities") }}
								</span>
							</vs-alert>
						</vx-card>
					</vs-tab>
					<vs-tab :label="$t('Groups.AssignedGroups')" icon-pack="feather" icon="icon-users">
						<vx-card no-shadow card-border class="mb-base mt-base" v-if="resource_data.group_id">
							<assigned-group-list
								class="p-4"
								:navbarOptions="false"
								:groupListIds="resource_data.group_id"
								:columns="columns"
							/>
						</vx-card>
						<vx-card no-shadow card-border class="mb-base mt-base" v-else>
							<vs-alert active class="mb-5" color="primary">
								<p class="g-label--normal text-primary" v-text="$t('Groups.NoAssignedGroups')"></p>
							</vs-alert>
						</vx-card>
					</vs-tab>
					<vs-tab :label="$t('StatusMobile.StatusMobile')" icon-pack="feather" icon="icon-smartphone">
						<vx-card no-shadow card-border class="mb-base mt-base">
							<status-mobile-list-management-view
								v-if="resource_data"
								:resource="resource_data"
							></status-mobile-list-management-view>
						</vx-card>
					</vs-tab>
				</vs-tabs>
			</vx-card>
		</div>
	</div>
</template>

<script>
import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";
import DateUtils from "@/helpers/DateUtils.js";
import StatusMobileListManagementView from "@/components/statusMobile/StatusMobileListManagementView";
import UploadedFile from "@/models/UploadedFile.js";
import "swiper/dist/css/swiper.min.css";
import {swiper, swiperSlide} from "vue-awesome-swiper";
import VisitPointAssignedList from "@/components/visit-point/list/VisitPointAssignedList";
import moduleActivity from "@/store/activity/moduleActivity.js";
import moduleResource from "@/store/resource/moduleResource.js";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import AssignedActivityList from "@/components/activity/AssignedActivityList";
import AssignedGroupList from "@/components/group/AssignedGroupList";
import HereMap from "@/components/Maps/Maps";
import moduleZonification from "@/store/zonification/moduleZonification.js";

export default {
	components: {
		HereMap,
		AssignedGroupList,
		AssignedActivityList,
		VisitPointAssignedList,
		StatusMobileListManagementView,
		swiper,
		swiperSlide,
	},
	data() {
		return {
			resource_data: null,
			user_not_found: false,
			avatar: require("@/assets/images/portrait/small/avatar-user-here.png"),
			urlDecoded: {fileName: new Date().getTime() + "", fileExtension: "unknown"},
			mounted: false,
			renderComponentMap: false,
			showMap: true,
			swiperOption: {
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			},
			columns: ["name", "description", "address", "hour_init", "hour_end"],
			resourceViewAssignedZones: [],
			mountedMapTab4: false,
			activeTab: 0,
		};
	},
	computed: {
		userAddress() {
			let str = "";
			for (const field in this.resource_data.location) {
				str += `${field} `;
			}
			return str;
		},
		addedOn() {
			return DateUtils.stringToDate(this.resource_data.added_on);
		},
		resourceDeletePermission() {
			return this.$store.getters.checkPermission("RESOURCES_D");
		},
		/**
		 * filtrar los campos adicioneles que no sean tipo imagen o tipo archivo
		 */
		additionalFieldsBasics() {
			const copy = JSON.parse(JSON.stringify(this.resource_data));
			const vpFilter = copy.category_json_properties.filter(
				({additional, type}) => additional === true && type !== "img" && type !== "file"
			);
			const filterObj = {};
			for (const key in copy.additional_info) {
				if (Object.hasOwnProperty.call(copy.additional_info, key)) {
					const element = copy.additional_info[key];
					if (vpFilter.some((vpfilter) => vpfilter.name === key)) {
						filterObj[key] = element;
					}
				}
			}
			return filterObj;
		},
		/**
		 * filtrar los campos adicioneles que sean tipo imagen o tipo archivo
		 */
		additionalFieldsImg() {
			const copy = JSON.parse(JSON.stringify(this.resource_data));
			const vpFilter = copy.category_json_properties.filter(
				({additional, type}) => additional === true && type === "img"
			);
			const filterObj = {};
			for (const key in copy.additional_info) {
				if (Object.hasOwnProperty.call(copy.additional_info, key)) {
					const element = copy.additional_info[key];
					if (vpFilter.some((vpfilter) => vpfilter.name === key)) {
						filterObj[key] = element;
					}
				}
			}
			return filterObj;
		},
		/**
		 * filtrar los campos adicioneles que sean tipo imagen o tipo archivo
		 */
		additionalFieldsFile() {
			const copy = {...this.resource_data};
			const vpFilter = copy.category_json_properties.filter(
				({additional, type}) => additional === true && type === "file"
			);
			const filterObj = {};
			for (const key in copy.additional_info) {
				if (Object.hasOwnProperty.call(copy.additional_info, key)) {
					const element = copy.additional_info[key];
					if (vpFilter.some((vpfilter) => vpfilter.name === key)) {
						filterObj[key] = element;
					}
				}
			}
			return filterObj;
		},
		renderImgFileExtension() {
			return (params) => {
				const obj = {...this.decodeUrl(params)};
				try {
					return require(`@/assets/images/svg-icons/${obj.fileExtension}.svg`);
				} catch (error) {
					return require("@/assets/images/svg-icons/file-plus.svg");
				}
			};
		},
		renderImgFileCompleteName() {
			return (params) => {
				const obj = {...this.decodeUrl(params)};
				return `${obj.fileName}.${obj.fileExtension}`;
			};
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
		widthMap() {
			let widthValue = "";
			if (this.$store.state.reduceButton && this.windowWidth > 600) {
				widthValue = "33vw";
			} else if (this.windowWidth < 600) {
				widthValue = "100%";
			}
			return widthValue;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		renderMapEmit(val) {
			this.renderComponentMap = val;
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: `${this.$t("Resource.List.CellRenderer.DeleteRecord")} "${this.resource_data.username}"`,
				accept: this.deleteRecord,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.$store
				.dispatch("moduleResource/removeResource", this.resource_data.id)
				.then((res) => {
					this.showDeleteSuccess();
				})
				.catch((err) => {
					throw new Error(err);
				});
		},
		confirmDeleteImei() {
			const imei = this.resource_data.imei || "";
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: `${this.$t("Crud.Delete")} IMEI`,
				text: `${this.$t("Record.DeleteRecordConfirmText")} "IMEI ${imei}"`,
				accept: this.deleteImeiCode,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteImeiCode() {
			this.$store
				.dispatch("moduleResource/removeImei", this.resource_data.id)
				.then((res) => {
					this.showDeleteSuccess();
				})
				.catch((err) => {
					throw new Error(err);
				});
		},
		showDeleteSuccess() {
			this.$router.push("/apps/resource/resource-list");
			this.$vs.notify({
				color: "success",
				title: this.$t("Object.UserDeleted.Title"),
				text: this.$t("Object.UserDeleted.Text"),
			});
		},
		getResourcePhoto() {
			const url = this.resource_data.img_url;
			if (!url) {
				return;
			}
			downloadFileFromFirebase(url)
				.then((res) => {
					this.avatar = res;
				})
				.catch((error) => {});
		},
		async downloadFile(urlFile) {
			const uploadedFile = new UploadedFile({});
			if (!urlFile) return;
			const obj = {...this.decodeUrl(urlFile)};
			this.openLoading();
			try {
				await uploadedFile.downloadFile(obj.fileName, urlFile);
				this.$vs.notify({
					color: "success",
					title: this.$t("Notification.DOWNLOAD_FINALIZED"),
					text: `${this.$t("Reports.FileName")} : ${obj.fileName}`,
					time: 8000,
					fixed: false,
				});
				this.closeLoading();
			} catch (error) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("UploadFiles.FileNotFound"),
					text: `${this.$t("UploadFiles.DownloadFailedText")}`,
					time: 8000,
					fixed: false,
				});
				this.closeLoading();
			}
		},
		decodeUrl(url = "") {
			const decodeUrl = decodeURIComponent(url);
			const urlSlashSplitted = decodeUrl.split("/");
			const splittedByQuestion = urlSlashSplitted[urlSlashSplitted.length - 1].split("?")[0];
			const splittedByDot = splittedByQuestion.split(".");
			if (Array.isArray(splittedByDot)) {
				if (splittedByDot.length > 2) {
					return {
						fileName: `${splittedByDot[0]}.${splittedByDot[1]}`,
						fileExtension: splittedByDot[splittedByDot.length - 1].toLowerCase(),
					};
				} else {
					return {fileName: splittedByDot[0], fileExtension: splittedByDot[1].toLowerCase()};
				}
			}
			return this.urlDecoded;
		},
		getZonesAssignedToResource(resourceId) {
			this.resourceViewAssignedZones = [];
			this.openLoading();
			this.$store
				.dispatch("moduleZonification/assignedZoneResourceById", resourceId)
				.then((res) => {
					if (res) {
						this.resourceViewAssignedZones = res.map(({zone_id}) => zone_id);
						this.mountedMapTab4 = true;
						this.closeLoading();
					} else {
						throw {err: "no found zones"};
					}
				})
				.catch((err) => {
					if (err.err === "no found zones") {
						this.closeLoading();
					}
					console.error(err);
				});
		},
	},
	filters: {
		capitalizeFilter: function (value) {
			if (!value) return "";
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1);
		},
	},
	watch: {
		activeTab(tabNum) {
			this.mountedMapTab4 = false;
			if (tabNum === 3) {
				this.getZonesAssignedToResource(this.resource_data.id);
			}
		},
	},
	created() {
		// Register Module Resource Module
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}
		if (!moduleActivity.isRegistered) {
			this.$store.registerModule("moduleActivity", moduleActivity);
			moduleActivity.isRegistered = true;
		}
		if (!moduleZonification.isRegistered) {
			this.$store.registerModule("moduleZonification", moduleZonification);
			moduleZonification.isRegistered = true;
		}
		const userId = this.$route.params.userId;
		const dataFilter = {
			ids: [userId],
		};
		this.$store
			.dispatch("moduleResource/fetchResourceFilterById", dataFilter)
			.then((res) => {
				this.resource_data = res.data.records[0];
				this.getResourcePhoto();
			})
			.catch((err) => {
				this.user_not_found = true;
				console.error(err);
			});
	},
	mounted() {
		this.mounted = true;
	},
	beforeDestroy() {
		this.$store.commit("moduleVisitPoint/CLEAR_ASSIGNED_VISIT_POINT");
	},
};
</script>

<style lang="scss" scoped>
#avatar-col {
	width: 10rem;
}

.img-container {
	width: 100%;
	height: 10rem;

	img {
		width: 100% !important;
		height: 120px !important;
		object-fit: cover;
	}
}

.img-avatar--cover {
	width: 100% !important;
	height: 100px !important;
	object-fit: cover;
}

#page-user-view {
	table {
		td {
			vertical-align: top;
			min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		&:not(.permissions-table) {
			td {
				@media screen and (max-width: 370px) {
					display: block;
				}
			}
		}
	}
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
	only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}
}

#buttonMap {
	.vs-icon {
		font-size: 1.5rem !important;
	}
}
</style>
